import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {AirportSummary} from '../../airport/models/airport-summary.model';

@Component({
  selector: 'app-confirm-remove-airport',
  templateUrl: './confirm-remove-airport.component.html',
  styleUrls: ['./confirm-remove-airport.component.scss']
})
export class ConfirmRemoveAirportComponent implements OnInit {

  airportSummary: AirportSummary;

  constructor(public dialogRef: MatDialogRef<ConfirmRemoveAirportComponent>,
              @Inject(MAT_DIALOG_DATA) public data) {
    this.airportSummary = data.airportSummary;
  }

  ngOnInit() {
  }

}
